import React from 'react';
import { clsx } from 'clsx';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger } from 'src/components/ui/select';

export const EscalationGroupSelect = <T extends FieldValues>({
  name = 'escalate_assign_group_id' as Path<T>,
  label,
  control,
  options = [],
}: {
  name?: Path<T>;
  label: React.ReactNode;
  control: Control<T>;
  options?: { id: number; name: string }[];
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        return (
          <label htmlFor={name} className={clsx(error && 'text-error')}>
            {label}
            <Select
              defaultValue={value}
              open={open}
              onOpenChange={setOpen}
              onValueChange={onChange}
            >
              <SelectTrigger
                className={clsx(
                  'w-full border bg-white rounded-sm-5',
                  error ? 'border-error text-error' : 'border-[#E3E6E8]',
                )}
              >
                <div>
                  <p className={'text-sm font-medium first-letter:capitalize'}>
                    <span>
                      {options.find((option) => `${option.id}` === `${value}`)?.name || 'support'}
                    </span>
                  </p>
                </div>
              </SelectTrigger>
              <SelectContent className={'bg-light'}>
                {options.map((option) => {
                  return (
                    <SelectItem
                      className={'px-4 rounded-none bg-white hover:!bg-[#a498ff1a]'}
                      key={option.id}
                      // Radix item values are typed as strings, but the numeric id is passed
                      // through as-is and ends up as the field value, so comparisons stringify both.
                      value={option.id as unknown as string}
                      indicatorHidden
                    >
                      <div className="flex flex-col">
                        <div className="flex gap-2 items-center">
                          <p
                            className={clsx(
                              'text-sm text-start relative first-letter:capitalize',
                              `${option.id}` === `${value}` ? 'font-semibold' : 'font-medium',
                            )}
                          >
                            <span>{option.name}</span>
                          </p>
                        </div>
                      </div>
                    </SelectItem>
                  );
                })}
              </SelectContent>
            </Select>
          </label>
        );
      }}
    />
  );
};
